import React from "react"
import RichText from "@components/rich-text"
import ButtonGroup from "@components/button-group"
import Column from "@components/column"

const CenteredTextBlock = ({ text: copyText, ctaList }) => (
  <Column className={'md:gap-10 gap-5 py-10 md:px-0'}>
    <RichText text={copyText} paragraphClassName="subheadline text-center max-w-centered-copy mx-auto" removeOtherClasses="true" />
    <ButtonGroup isFullWidth={true} list={ctaList} />
  </Column>
)

export default CenteredTextBlock
